import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { SelectAddressContainer } from './SelectAddressContainer.js';

const SelectAddress = (props)=>/*#__PURE__*/ React.createElement(SelectAddressContainer, swcHelpers.extends({}, props))
;

export { SelectAddress };
//# sourceMappingURL=Layout.js.map
